import { Music, Facebook, Instagram, MessageCircle } from 'lucide-react';
import { SOCIALS } from '../socialLinks';
import { useLang } from '../i18n';

const SOCIAL_ICONS = {
  facebook: Facebook,
  instagram: Instagram,
  whatsapp: MessageCircle,
};

const Footer = () => {
  const { t } = useLang();
  return (
    <footer
      data-testid="footer"
      className="relative z-10 border-t border-[#d4af37]/15 bg-[#050b0e]"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-10">
          <div>
            <div className="flex items-center gap-3 mb-5">
              <span className="w-10 h-10 rounded-full border border-[#d4af37]/50 flex items-center justify-center bg-[#0c171c]">
                <Music size={16} className="text-[#e6c687]" strokeWidth={1.5} />
              </span>
              <span className="font-display text-2xl text-[#f3e5ab]">
                Trinity Masterclass
              </span>
            </div>
            <p className="font-mono-alt text-[10px] tracking-[0.3em] uppercase text-[#a3b1b6] leading-loose">
              Amici per la Musica APS
              <br />
              {t('footer.tagline')}
            </p>
          </div>

          <div className="text-left md:text-right">
            <p className="font-mono-alt text-[10px] tracking-[0.3em] uppercase text-[#e6c687] mb-3">
              {t('footer.contacts')}
            </p>
            <a
              data-testid="footer-email-link"
              href="mailto:info@trinitymusicalschool.net"
              className="font-display italic text-xl text-[#f3e5ab] hover:text-[#d4af37] transition-colors duration-300"
            >
              info@trinitymusicalschool.net
            </a>
            <p className="mt-3 text-xs text-[#a3b1b6]">
              Tel. 0425 166 6483 · 391 308 4761 — www.trinitymusicalschool.net
            </p>
            <p className="mt-1.5 text-xs text-[#a3b1b6]">
              Rovigo · Polesella (RO) — Anno Accademico 2026–2027
            </p>
            <p className="mt-6 font-mono-alt text-[10px] tracking-[0.3em] uppercase text-[#e6c687] mb-3">
              {t('footer.follow')}
            </p>
            <div className="flex md:justify-end gap-3">
              {SOCIALS.map((s) => {
                const Icon = SOCIAL_ICONS[s.id];
                return (
                  <a
                    key={s.id}
                    data-testid={`footer-social-${s.id}-link`}
                    href={s.href}
                    target="_blank"
                    rel="noreferrer"
                    aria-label={s.label}
                    className="w-11 h-11 rounded-full border border-[#d4af37]/35 flex items-center justify-center text-[#e6c687] transition-all duration-300 hover:bg-[#d4af37]/15 hover:border-[#d4af37]/60 hover:-translate-y-0.5"
                  >
                    <Icon size={17} strokeWidth={1.6} />
                  </a>
                );
              })}
            </div>
          </div>
        </div>

        <div className="hairline-gold mt-12 mb-6" />
        <p className="font-mono-alt text-[9px] tracking-[0.25em] uppercase text-[#a3b1b6]/50">
          {t('footer.rights')}
        </p>
      </div>
    </footer>
  );
};

export default Footer;
